import { ReactNode } from 'react';
import BgNsAccordion from '@britishgasenergy/react-nucleus/dist/nuc-components/NsAccordion';

type NsAccordionProps = {
  children?: ReactNode | ReactNode[];
  heading?: ReactNode;
  headingTag?: 'h2' | 'h3';
  id?: string;
  testId?: string;
};

export const NsAccordion = (props: NsAccordionProps) => {
  const {
    children,
    heading,
    headingTag: HeadingTag = 'h2',
    id,
    testId
  } = props;

  return (
    <BgNsAccordion id={id} data-testid={testId}>
      {heading && <HeadingTag slot="heading">{heading}</HeadingTag>}
      {children}
    </BgNsAccordion>
  );
};
